import Layout from "../../containers/Layout";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const PrivacyPolicy = () => {
  return (
    <Layout mt={16}>
      <Seo
        title="Privacy Policy"
        description="How Spanish with Alex collects, uses, and protects your personal data."
        path="/privacy-policy"
      />
      <BoxInfoTemplate
        title=""
        subTitle="Privacy Policy"
        mainText="Your data is important. Here's how we handle it."
        iconType="lock"
        showQuotes={false}
        showShadow={true}
        borderColor="purple"
      />

      <div
        className="privacy-container"
        style={{ textAlign: "left", padding: "1rem 0" }}
      >
        <h2 style={{ marginBottom: "1rem" }}>1. Who We Are</h2>
        <p style={{ marginBottom: "1rem" }}>
          Spanish with Alex is an independent platform that offers Spanish
          lessons, online materials, and in-person immersion programs. Your
          privacy matters to us.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>2. What Data We Collect</h2>
        <ul style={{ marginBottom: "1rem" }}>
          <li>
            Email address (when you sign up for the newsletter or book a lesson)
          </li>
          <li>Name and contact info (when booking a session)</li>
          <li>
            Lesson preferences and progress (to personalize your experience)
          </li>
          <li>Anonymous usage data (for improving the website)</li>
        </ul>

        <h2 style={{ marginBottom: "1rem" }}>3. How We Use Your Data</h2>
        <p style={{ marginBottom: "1rem" }}>We use your data to:</p>
        <ul style={{ marginBottom: "1rem" }}>
          <li>Send lesson reminders and educational updates</li>
          <li>Provide access to your materials and booking history</li>
          <li>Improve our teaching methods and content</li>
        </ul>

        <h2 style={{ marginBottom: "1rem" }}>4. Third-Party Services</h2>
        <p style={{ marginBottom: "1rem" }}>
          We may use third-party services like Google Analytics and Stripe.
          These services only receive the necessary data to perform their role
          and comply with GDPR.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>5. Your Rights</h2>
        <p style={{ marginBottom: "1rem" }}>
          You have the right to access, modify, or delete your personal data at
          any time. Just join the newsletter and respont to that email.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>6. Data Retention</h2>
        <p style={{ marginBottom: "1rem" }}>
          We retain data only as long as needed for your educational use or as
          required by law.
        </p>

        <h2 style={{ marginBottom: "1rem" }}>7. Updates</h2>
        <p style={{ marginBottom: "1rem" }}>
          This policy may be updated occasionally. We'll notify you via email if
          significant changes occur.
        </p>

        <p className="signature" style={{ marginTop: "1rem" }}>
          Thanks for trusting Spanish with Alex!
        </p>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
